import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const MediumIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
q      width="500"
      zoomAndPan="magnify"
      viewBox="0 0 375 374.999991"
      height="500"
      preserveAspectRatio="xMidYMid meet"
      version="1.0"
    >
      <defs>
        <clipPath id="0fa59c7662">
          <path
            d="M 306 0 L 375 0 L 375 82 L 306 82 Z M 306 0 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="b965e58328">
          <path
            d="M 304.664062 -24.101562 L 411.257812 -130.699219 L 517.855469 -24.101562 L 411.257812 82.496094 Z M 304.664062 -24.101562 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="4d71ee9e12">
          <path
            d="M 304.664062 -24.101562 L 411.257812 -130.699219 L 517.855469 -24.101562 L 411.257812 82.496094 Z M 304.664062 -24.101562 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="4f3aa1bbea">
          <path
            d="M 305 0 L 375 0 L 375 83 L 305 83 Z M 305 0 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="b7c5f5c156">
          <path
            d="M 304.664062 -24.101562 L 411.257812 -130.699219 L 517.855469 -24.101562 L 411.257812 82.496094 Z M 304.664062 -24.101562 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="f2f1a90007">
          <path
            d="M 304.664062 -24.101562 L 411.257812 -130.699219 L 517.855469 -24.101562 L 411.257812 82.496094 Z M 304.664062 -24.101562 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="5231e44429">
          <path d="M 0 0 L 70 0 L 70 82 L 0 82 Z M 0 0 " clip-rule="nonzero" />
        </clipPath>
        <clipPath id="f42c10ba1d">
          <path
            d="M -143.007812 -24.101562 L -36.410156 -130.699219 L 70.183594 -24.101562 L -36.410156 82.496094 Z M -143.007812 -24.101562 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="b116f1c1f3">
          <path
            d="M -143.007812 -24.101562 L -36.410156 -130.699219 L 70.183594 -24.101562 L -36.410156 82.496094 Z M -143.007812 -24.101562 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="eb47b91c43">
          <path d="M 0 0 L 71 0 L 71 83 L 0 83 Z M 0 0 " clip-rule="nonzero" />
        </clipPath>
        <clipPath id="42a034c351">
          <path
            d="M -143.007812 -24.101562 L -36.410156 -130.699219 L 70.183594 -24.101562 L -36.410156 82.496094 Z M -143.007812 -24.101562 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="d6ca6f45b7">
          <path
            d="M -143.007812 -24.101562 L -36.410156 -130.699219 L 70.183594 -24.101562 L -36.410156 82.496094 Z M -143.007812 -24.101562 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="b182cb3ee9">
          <path
            d="M 297 301 L 375 301 L 375 375 L 297 375 Z M 297 301 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="1ee17bf03b">
          <path
            d="M 296.210938 407.050781 L 402.808594 300.457031 L 509.40625 407.050781 L 402.808594 513.648438 Z M 296.210938 407.050781 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="0a58283014">
          <path
            d="M 296.210938 407.050781 L 402.808594 300.457031 L 509.40625 407.050781 L 402.808594 513.648438 Z M 296.210938 407.050781 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="1e3385f865">
          <path
            d="M 296 300 L 375 300 L 375 375 L 296 375 Z M 296 300 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="c450f088f0">
          <path
            d="M 296.210938 407.050781 L 402.808594 300.457031 L 509.40625 407.050781 L 402.808594 513.648438 Z M 296.210938 407.050781 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="8e610f7c79">
          <path
            d="M 296.210938 407.050781 L 402.808594 300.457031 L 509.40625 407.050781 L 402.808594 513.648438 Z M 296.210938 407.050781 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="d26540a98e">
          <path
            d="M 0 301 L 77 301 L 77 375 L 0 375 Z M 0 301 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="7843801018">
          <path
            d="M -135.855469 407.050781 L -29.257812 300.457031 L 77.339844 407.050781 L -29.257812 513.648438 Z M -135.855469 407.050781 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="25aee65f50">
          <path
            d="M -135.855469 407.050781 L -29.257812 300.457031 L 77.339844 407.050781 L -29.257812 513.648438 Z M -135.855469 407.050781 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="cff67df981">
          <path
            d="M 0 300 L 78 300 L 78 375 L 0 375 Z M 0 300 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="9980610308">
          <path
            d="M -135.855469 407.050781 L -29.257812 300.457031 L 77.339844 407.050781 L -29.257812 513.648438 Z M -135.855469 407.050781 "
            clip-rule="nonzero"
          />
        </clipPath>
        <clipPath id="86a6b087dd">
          <path
            d="M -135.855469 407.050781 L -29.257812 300.457031 L 77.339844 407.050781 L -29.257812 513.648438 Z M -135.855469 407.050781 "
            clip-rule="nonzero"
          />
        </clipPath>
      </defs>
      <path
        fill="#ffffff"
        d="M 34.574219 -71.765625 L 340.425781 -71.765625 C 399.09375 -71.609375 446.609375 -24.09375 446.765625 34.570312 L 446.765625 340.425781 C 446.609375 399.089844 399.09375 446.605469 340.429688 446.761719 L 34.574219 446.765625 C -24.089844 446.605469 -71.609375 399.089844 -71.765625 340.429688 L -71.765625 34.574219 C -71.609375 -24.09375 -24.089844 -71.609375 34.570312 -71.765625 Z M 34.574219 -71.765625 "
        fill-opacity="1"
        fill-rule="evenodd"
      />
      <path
        fill="#1c1c27"
        d="M 208.105469 187.496094 C 208.105469 237.949219 167.488281 278.851562 117.375 278.851562 C 67.265625 278.851562 26.648438 237.960938 26.648438 187.496094 C 26.648438 137.035156 67.269531 96.148438 117.375 96.148438 C 167.484375 96.148438 208.105469 137.046875 208.105469 187.496094 Z M 307.640625 187.496094 C 307.640625 234.992188 287.328125 273.492188 262.273438 273.492188 C 237.222656 273.492188 216.910156 234.980469 216.910156 187.496094 C 216.910156 140.015625 237.222656 101.503906 262.273438 101.503906 C 287.328125 101.503906 307.640625 140.015625 307.640625 187.496094 Z M 348.351562 187.496094 C 348.351562 230.050781 341.207031 264.542969 332.394531 264.542969 C 323.582031 264.542969 316.441406 230.039062 316.441406 187.496094 C 316.441406 144.957031 323.582031 110.453125 332.398438 110.453125 C 341.210938 110.453125 348.351562 144.949219 348.351562 187.496094 Z M 348.351562 187.496094 "
        fill-opacity="1"
        fill-rule="nonzero"
      />
      <g clip-path="url(#0fa59c7662)">
        <g clip-path="url(#b965e58328)">
          <g clip-path="url(#4d71ee9e12)">
            <path
              fill="#1c1c27"
              d="M 306.085938 -24.101562 L 411.382812 -129.398438 L 516.679688 -24.101562 L 411.382812 81.195312 Z M 306.085938 -24.101562 "
              fill-opacity="1"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clip-path="url(#4f3aa1bbea)">
        <g clip-path="url(#b7c5f5c156)">
          <g clip-path="url(#f2f1a90007)">
            <path
              fill="#070404"
              d="M 517.390625 -23.390625 L 412.09375 81.90625 C 411.695312 82.304688 411.070312 82.304688 410.671875 81.90625 L 305.375 -23.390625 C 304.976562 -23.789062 304.976562 -24.414062 305.375 -24.8125 L 410.671875 -130.109375 C 411.070312 -130.507812 411.695312 -130.507812 412.09375 -130.109375 L 517.390625 -24.8125 C 517.789062 -24.414062 517.789062 -23.789062 517.390625 -23.390625 Z M 411.382812 79.773438 L 515.257812 -24.101562 L 411.382812 -127.976562 L 307.507812 -24.101562 Z M 411.382812 79.773438 "
              fill-opacity="1"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clip-path="url(#5231e44429)">
        <g clip-path="url(#f42c10ba1d)">
          <g clip-path="url(#b116f1c1f3)">
            <path
              fill="#1c1c27"
              d="M -141.585938 -24.101562 L -36.285156 -129.398438 L 69.011719 -24.101562 L -36.285156 81.195312 Z M -141.585938 -24.101562 "
              fill-opacity="1"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clip-path="url(#eb47b91c43)">
        <g clip-path="url(#42a034c351)">
          <g clip-path="url(#d6ca6f45b7)">
            <path
              fill="#070404"
              d="M 69.722656 -23.390625 L -35.574219 81.90625 C -35.972656 82.304688 -36.601562 82.304688 -37 81.90625 L -142.296875 -23.390625 C -142.695312 -23.789062 -142.695312 -24.414062 -142.296875 -24.8125 L -37 -130.109375 C -36.601562 -130.507812 -35.972656 -130.507812 -35.574219 -130.109375 L 69.722656 -24.8125 C 70.121094 -24.414062 70.121094 -23.789062 69.722656 -23.390625 Z M -36.285156 79.773438 L 67.585938 -24.101562 L -36.285156 -127.976562 L -140.160156 -24.101562 Z M -36.285156 79.773438 "
              fill-opacity="1"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clip-path="url(#b182cb3ee9)">
        <g clip-path="url(#1ee17bf03b)">
          <g clip-path="url(#0a58283014)">
            <path
              fill="#1c1c27"
              d="M 297.636719 407.050781 L 402.933594 301.753906 L 508.230469 407.050781 L 402.933594 512.351562 Z M 297.636719 407.050781 "
              fill-opacity="1"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clip-path="url(#1e3385f865)">
        <g clip-path="url(#c450f088f0)">
          <g clip-path="url(#8e610f7c79)">
            <path
              fill="#070404"
              d="M 508.941406 407.765625 L 403.644531 513.0625 C 403.246094 513.460938 402.621094 513.460938 402.222656 513.0625 L 296.925781 407.765625 C 296.527344 407.367188 296.527344 406.738281 296.925781 406.339844 L 402.222656 301.042969 C 402.621094 300.644531 403.246094 300.644531 403.644531 301.042969 L 508.941406 406.339844 C 509.339844 406.738281 509.339844 407.367188 508.941406 407.765625 Z M 402.933594 510.925781 L 506.808594 407.050781 L 402.933594 303.175781 L 299.058594 407.050781 Z M 402.933594 510.925781 "
              fill-opacity="1"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clip-path="url(#d26540a98e)">
        <g clip-path="url(#7843801018)">
          <g clip-path="url(#25aee65f50)">
            <path
              fill="#1c1c27"
              d="M -134.433594 407.050781 L -29.132812 301.753906 L 76.164062 407.050781 L -29.132812 512.351562 Z M -134.433594 407.050781 "
              fill-opacity="1"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
      <g clip-path="url(#cff67df981)">
        <g clip-path="url(#9980610308)">
          <g clip-path="url(#86a6b087dd)">
            <path
              fill="#070404"
              d="M 76.875 407.765625 L -28.421875 513.0625 C -28.820312 513.460938 -29.445312 513.460938 -29.84375 513.0625 L -135.144531 407.765625 C -135.542969 407.367188 -135.542969 406.738281 -135.144531 406.339844 L -29.84375 301.042969 C -29.445312 300.644531 -28.820312 300.644531 -28.421875 301.042969 L 76.875 406.339844 C 77.273438 406.738281 77.273438 407.367188 76.875 407.765625 Z M -29.132812 510.925781 L 74.742188 407.050781 L -29.132812 303.175781 L -133.007812 407.050781 Z M -29.132812 510.925781 "
              fill-opacity="1"
              fill-rule="nonzero"
            />
          </g>
        </g>
      </g>
      <path
        fill="#1c1c27"
        d="M 324.277344 0 L 50.722656 0 C 22.933594 0 0 22.933594 0 50.722656 L 0 324.277344 C 0 352.066406 22.933594 375 50.722656 375 L 324.277344 375 C 352.066406 375 375 352.066406 375 324.277344 L 375 50.722656 C 375 22.933594 352.066406 0 324.277344 0 Z M 363.792969 54.53125 L 363.792969 324.277344 C 363.792969 345.867188 345.867188 363.792969 324.277344 363.792969 L 50.722656 363.792969 C 29.132812 363.792969 11.207031 345.867188 11.207031 324.277344 L 11.207031 50.722656 C 11.207031 29.132812 29.132812 11.207031 50.722656 11.207031 L 324.277344 11.207031 C 345.867188 11.207031 363.792969 29.132812 363.792969 50.722656 Z M 363.792969 54.53125 "
        fill-opacity="1"
        fill-rule="nonzero"
      />
    </svg>
  </SvgIcon>
);

export default MediumIcon;
